import { FormattedMessage, useIntl } from "react-intl";

import { CtaModal, CtaModalProps } from "ui/CtaModal";
import { DiscardBagIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

type ProductAlreadyInboundedModalProps = Pick<CtaModalProps, "onClickCta">;

export function ProductAlreadyInboundedModal({ onClickCta }: ProductAlreadyInboundedModalProps) {
  const intl = useIntl();
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={onClickCta}
      headerIcon={<DiscardBagIcon boxSize="120px" />}
      title={intl.formatMessage({
        id: "flows.inbound.components.product-already-inbounded-modal.search-during-dropping-variant.title",
      })}
      ctaLabel={intl.formatMessage({
        id: "generic.actions.go-back",
      })}
      body={
        <BodyM textAlign="center">
          <FormattedMessage id="flows.inbound.components.product-already-inbounded-modal.search-during-dropping-variant.body" />
        </BodyM>
      }
    />
  );
}
